<template>
    <div class="search-page">
        <!-- 移动端搜索结果页面 -->
        <div class="mobile-search-container">
            <!-- Banner区域 -->
            <div class="mobile-search-banner">
                <div class="mobile-search-banner__content">
                    <h1 class="mobile-search-banner__title">搜索结果</h1>
                    <p class="mobile-search-banner__keyword">关键词: {{ keyword }}</p>
                </div>
            </div>

            <!-- Tab按钮区域 -->
            <div class="mobile-search-tabs">
                <div class="mobile-search-tabs__grid">
                    <button
                        :class="['mobile-search-tabs__button', { 'mobile-search-tabs__button--active': activeTab === 'product' }]"
                        @click="switchTab('product')"
                    >
                        产品中心
                        <span class="mobile-search-tabs__count" v-if="searchResults.product.length > 0">({{ searchResults.product.length }})</span>
                    </button>
                    <button
                        :class="['mobile-search-tabs__button', { 'mobile-search-tabs__button--active': activeTab === 'solution' }]"
                        @click="switchTab('solution')"
                    >
                        解决方案
                        <span class="mobile-search-tabs__count" v-if="searchResults.solution.length > 0">({{ searchResults.solution.length }})</span>
                    </button>
                    <button
                        :class="['mobile-search-tabs__button', { 'mobile-search-tabs__button--active': activeTab === 'news' }]"
                        @click="switchTab('news')"
                    >
                        新闻动态
                        <span class="mobile-search-tabs__count" v-if="searchResults.news.length > 0">({{ searchResults.news.length }})</span>
                    </button>
                    <button
                        :class="['mobile-search-tabs__button', { 'mobile-search-tabs__button--active': activeTab === 'investor' }]"
                        @click="switchTab('investor')"
                    >
                        投资者关系
                        <span class="mobile-search-tabs__count" v-if="searchResults.investor.length > 0">({{ searchResults.investor.length }})</span>
                    </button>
                </div>
            </div>

            <!-- 加载状态 -->
            <div v-if="isLoading" class="mobile-search-loading">
                <i class="el-icon-loading"></i>
                <p>搜索中...</p>
            </div>

            <!-- 搜索结果列表 -->
            <div v-else class="mobile-search-results">
                <!-- 产品中心结果 -->
                <div v-if="activeTab === 'product' && searchResults.product.length > 0" class="mobile-search-list">
                    <div
                        v-for="item in searchResults.product"
                        :key="item.id"
                        class="mobile-search-card"
                        @click="handleResultClick(item)"
                    >
                        <div class="mobile-search-card__content">
                            <h3 class="mobile-search-card__title">{{ item.name }}</h3>
                            <p class="mobile-search-card__category">{{ item.categoryName }}</p>
                        </div>
                        <div class="mobile-search-card__arrow">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </div>

                <!-- 解决方案结果 -->
                <div v-if="activeTab === 'solution' && searchResults.solution.length > 0" class="mobile-search-list">
                    <div
                        v-for="item in searchResults.solution"
                        :key="item.id"
                        class="mobile-search-card"
                        @click="handleResultClick(item)"
                    >
                        <div class="mobile-search-card__content">
                            <h3 class="mobile-search-card__title">{{ item.name }}</h3>
                            <p class="mobile-search-card__category">{{ item.categoryName }}</p>
                        </div>
                        <div class="mobile-search-card__arrow">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </div>

                <!-- 新闻动态结果 -->
                <div v-if="activeTab === 'news' && searchResults.news.length > 0" class="mobile-search-list">
                    <div
                        v-for="item in searchResults.news"
                        :key="item.id"
                        class="mobile-search-card"
                        @click="handleResultClick(item)"
                    >
                        <div class="mobile-search-card__content">
                            <h3 class="mobile-search-card__title">{{ item.name }}</h3>
                            <p class="mobile-search-card__date">{{ item.publishdate }}</p>
                        </div>
                        <div class="mobile-search-card__arrow">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </div>

                <!-- 投资者关系结果 -->
                <div v-if="activeTab === 'investor' && searchResults.investor.length > 0" class="mobile-search-list">
                    <div
                        v-for="item in searchResults.investor"
                        :key="item.id"
                        class="mobile-search-card"
                        @click="handleResultClick(item)"
                    >
                        <div class="mobile-search-card__content">
                            <h3 class="mobile-search-card__title">{{ item.name }}</h3>
                            <p class="mobile-search-card__date">{{ item.publishdate }}</p>
                        </div>
                        <div class="mobile-search-card__arrow">
                            <span class="el-icon-arrow-right"></span>
                        </div>
                    </div>
                </div>

                <!-- 空状态 -->
                <div v-if="getCurrentResults().length === 0" class="mobile-search-empty">
                    <div class="mobile-search-empty__icon">🔍</div>
                    <p class="mobile-search-empty__text">暂无搜索结果</p>
                    <p class="mobile-search-empty__tip">换个关键词试试吧</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            keyword: '',
            activeTab: 'product', // 默认显示产品中心
            isLoading: false,
            searchResults: {
                product: [],
                solution: [],
                news: [],
                investor: []
            },
            allData: {
                product: [],
                solution: [],
                news: [],
                investor: []
            }
        };
    },
    methods: {
        async loadAllData() {
            // 加载所有模块的数据
            this.isLoading = true;
            try {
                await Promise.all([
                    this.loadProductData(),
                    this.loadSolutionData(),
                    this.loadNewsData(),
                    this.loadInvestorData()
                ]);
                // 构建搜索索引并执行搜索
                this.performSearch();
            } catch (error) {
                console.error('加载数据失败:', error);
                this.$message.error('数据加载失败，请稍后重试');
            } finally {
                this.isLoading = false;
            }
        },
        loadProductData() {
            // 加载产品中心数据 - 需要遍历到第三级分类
            return new Promise((resolve, reject) => {
                // 第一步：获取产品分类树
                this.$api.post("/Client/getBusinessDataTree", { businessType: "产品中心" },
                    async (res) => {
                        if (res.code === "200" && res.data) {
                            const products = [];
                            // 遍历树形数据，获取所有三级分类
                            const categoryPromises = [];
                            
                            res.data.forEach(level1 => {
                                // 第一级：顶级分类
                                if (level1.children && level1.children.length > 0) {
                                    level1.children.forEach(level2 => {
                                        // 第二级：二级分类
                                        if (level2.children && level2.children.length > 0) {
                                            level2.children.forEach(level3 => {
                                                // 第三级：三级分类，使用这个ID获取产品列表
                                                const promise = new Promise((catResolve) => {
                                                    this.$api.post("/Client/getBusinessData", {
                                                        treePath: "",
                                                        level: 4,
                                                        businessType: "产品中心",
                                                        pageSize: 1000, // 获取所有产品
                                                        pageIndex: 1,
                                                        pId: level3.id,
                                                        isShowIndex: 0
                                                    },
                                                    (productRes) => {
                                                        if (productRes.code === "200" && productRes.data) {
                                                            productRes.data.forEach(product => {
                                                                products.push({
                                                                    id: product.id,
                                                                    name: product.business_name,
                                                                    categoryName: level3.label,
                                                                    parent_id: product.parent_id,
                                                                    parent_id3: product.parent_id3,
                                                                    type: 'product'
                                                                });
                                                            });
                                                        }
                                                        catResolve();
                                                    },
                                                    () => {
                                                        catResolve();
                                                    });
                                                });
                                                categoryPromises.push(promise);
                                            });
                                        }
                                    });
                                }
                            });
                            
                            // 等待所有分类的产品加载完成
                            await Promise.all(categoryPromises);
                            this.allData.product = products;
                        }
                        resolve();
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        loadSolutionData() {
            // 加载解决方案数据 - 需要遍历到第三级分类
            return new Promise((resolve, reject) => {
                // 第一步：获取解决方案分类树
                this.$api.post("/Client/getBusinessDataTree", { businessType: "解决方案" },
                    async (res) => {
                        if (res.code === "200" && res.data) {
                            const solutions = [];
                            // 遍历树形数据，获取所有三级分类
                            const categoryPromises = [];
                            
                            res.data.forEach(level1 => {
                                // 第一级：顶级分类
                                if (level1.children && level1.children.length > 0) {
                                    level1.children.forEach(level2 => {
                                        // 第二级：二级分类
                                        if (level2.children && level2.children.length > 0) {
                                            level2.children.forEach(level3 => {
                                                // 第三级：三级分类，使用这个ID获取解决方案列表
                                                const promise = new Promise((catResolve) => {
                                                    this.$api.post("/Client/getBusinessData", {
                                                        treePath: "",
                                                        level: 4,
                                                        businessType: "解决方案",
                                                        pageSize: 1000, // 获取所有解决方案
                                                        pageIndex: 1,
                                                        pId: level3.id,
                                                        isShowIndex: 0
                                                    },
                                                    (solutionRes) => {
                                                        if (solutionRes.code === "200" && solutionRes.data) {
                                                            solutionRes.data.forEach(solution => {
                                                                solutions.push({
                                                                    id: solution.id,
                                                                    name: solution.business_name,
                                                                    categoryName: level3.label,
                                                                    parent_id: solution.parent_id,
                                                                    parent_id3: solution.parent_id3,
                                                                    type: 'solution'
                                                                });
                                                            });
                                                        }
                                                        catResolve();
                                                    },
                                                    () => {
                                                        catResolve();
                                                    });
                                                });
                                                categoryPromises.push(promise);
                                            });
                                        }
                                    });
                                }
                            });
                            
                            // 等待所有分类的解决方案加载完成
                            await Promise.all(categoryPromises);
                            this.allData.solution = solutions;
                        }
                        resolve();
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        loadNewsData() {
            // 加载新闻动态数据（四个类型）
            const newsTypes = ['NT01', 'NT02', 'NT03', 'NT04'];
            const promises = newsTypes.map(type => {
                return new Promise((resolve, reject) => {
                    this.$api.post("/Client/getNewsCenterlist", {
                        pageSize: 100,
                        pageIndex: 1,
                        modelitem: type,
                        newsmodel: "NewsType"
                    },
                    (res) => {
                        if (res.code === "200" && res.data) {
                            const news = res.data.map(item => ({
                                id: item.id,
                                name: item.news_title,
                                publishdate: item.publishdate,
                                modelitem: type,
                                newsmodel: "NewsType",
                                type: 'news'
                            }));
                            this.allData.news = this.allData.news.concat(news);
                        }
                        resolve();
                    },
                    (error) => {
                        reject(error);
                    });
                });
            });
            return Promise.all(promises);
        },
        loadInvestorData() {
            // 加载投资者关系数据（两个类型）
            const investorTypes = ['IT01', 'IT02'];
            const promises = investorTypes.map(type => {
                return new Promise((resolve, reject) => {
                    this.$api.post("/Client/getNewsCenterlist", {
                        pageSize: 100,
                        pageIndex: 1,
                        modelitem: type,
                        newsmodel: "InvestType"
                    },
                    (res) => {
                        if (res.code === "200" && res.data) {
                            const investor = res.data.map(item => ({
                                id: item.id,
                                name: item.news_title,
                                publishdate: item.publishdate,
                                modelitem: type,
                                newsmodel: "InvestType",
                                type: 'investor'
                            }));
                            this.allData.investor = this.allData.investor.concat(investor);
                        }
                        resolve();
                    },
                    (error) => {
                        reject(error);
                    });
                });
            });
            return Promise.all(promises);
        },
        performSearch() {
            // 执行搜索匹配
            if (!this.keyword) {
                return;
            }
            
            const keyword = this.keyword.toLowerCase();
            
            // 搜索产品中心
            this.searchResults.product = this.allData.product.filter(item => 
                item.name.toLowerCase().includes(keyword)
            );
            
            // 搜索解决方案
            this.searchResults.solution = this.allData.solution.filter(item => 
                item.name.toLowerCase().includes(keyword)
            );
            
            // 搜索新闻动态
            this.searchResults.news = this.allData.news.filter(item => 
                item.name.toLowerCase().includes(keyword)
            );
            
            // 搜索投资者关系
            this.searchResults.investor = this.allData.investor.filter(item => 
                item.name.toLowerCase().includes(keyword)
            );
        },
        switchTab(tab) {
            // 切换tab
            this.activeTab = tab;
        },
        getCurrentResults() {
            // 获取当前tab的搜索结果
            return this.searchResults[this.activeTab] || [];
        },
        handleResultClick(item) {
            // 处理结果点击，跳转到详情页
            if (item.type === 'product') {
                // 跳转到产品详情页
                this.$router.push({
                    path: '/Client/Business/Product',
                    query: {
                        tpid: item.parent_id3,
                        tid: item.parent_id,
                        id: item.id
                    }
                });
            } else if (item.type === 'solution') {
                // 跳转到解决方案详情页
                this.$router.push({
                    path: '/Client/Business/Solution',
                    query: {
                        tpid: item.parent_id3,
                        tid: item.parent_id,
                        id: item.id
                    }
                });
            } else if (item.type === 'news') {
                // 跳转到新闻详情页
                this.$router.push({
                    path: '/Client/NewsDetails',
                    query: {
                        id: item.id,
                        modelitem: item.modelitem,
                        newsmodel: item.newsmodel
                    }
                });
            } else if (item.type === 'investor') {
                // 跳转到投资者关系详情页
                this.$router.push({
                    path: '/Client/InvestorRelationsDetails',
                    query: {
                        id: item.id,
                        modelitem: item.modelitem,
                        newsmodel: item.newsmodel
                    }
                });
            }
        }
    },
    mounted() {
        // 获取搜索关键词
        this.keyword = this.$route.query.keyword || '';
        
        if (!this.keyword) {
            this.$message.warning('请输入搜索关键词');
            this.$router.go(-1);
            return;
        }
        
        // 加载所有数据并执行搜索
        this.loadAllData();
    },
    watch: {
        '$route.query.keyword': {
            handler: function (newKeyword) {
                // 监听关键词变化，重新搜索
                if (newKeyword) {
                    this.keyword = newKeyword;
                    this.loadAllData();
                }
            }
        }
    }
};
</script>

<style scoped>
@import '../../../assets/client/search-mobile.css';
</style>

